module.exports = __webpack_public_path__ + "img/julong_zhizhao.7c3ae65a.jpg";